import { EntityType } from '@frontend/common';
import { Form } from '@frontend/components/forms';
import { EnumSelectListV2 } from '@frontend/components/select';
import { OrderClient } from '@frontend/order/api';
import { CreateOrder, Order } from '@frontend/order/types';
import { useFormValues } from '@frontend/repository';
import { useMemo } from 'react';

import useOrderCreate from './order-create.controller';

const ID = 'order-create';

const OrderCreate = () => {
    const viewProps = useOrderCreate();
    const formValues = useFormValues<CreateOrder>(ID);

    const enumOverwrite = useMemo(() => new Map<keyof CreateOrder, keyof typeof EnumSelectListV2>([['state', 'order_status']]), []);

    return (
        <div id={ID}>
            <Form<Order, CreateOrder>
                id={ID}
                useStaticId
                type={EntityType.ORDER}
                value={{}}
                dispatch={viewProps.dispatch}
                show={['state', 'number', 'user_id', 'product_id', 'quantity', 'spot_id']}
                required={['user_id', 'product_id']}
                submitDisabled={!viewProps.account_id || !formValues?.user_id || !formValues?.product_id}
                onCancel={viewProps.onCancel}
                onSubmit={(v) => OrderClient.postOrder(viewProps.account_id!, v)}
                onSubmitSuccess={viewProps.onSubmitSuccess}
                enumOverwrite={enumOverwrite}
            />
        </div>
    );
};

export default OrderCreate;
